import { Button } from "@mui/joy";
import React from "react";
import Webcam from "react-webcam";

export const VideoRecordingCapture = ({ setVideo }: { setVideo: (i: any) => void }) => {
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);



  const handleDataAvailable = React.useCallback(
    // @ts-ignore
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(true);
    // @ts-ignore
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/mp4"
    });
    // @ts-ignore
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    // @ts-ignore
    mediaRecorderRef.current.start();
    
  }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable]);

  const handleStopCaptureClick = React.useCallback(() => {
    // @ts-ignore
    mediaRecorderRef.current.stop();
    setCapturing(false);
  }, [mediaRecorderRef, setCapturing]);

  const handleSubmit = React.useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/webm"
      });
      
      setVideo(blob);
    }
  }, [recordedChunks, setVideo]);

  return (
    <>
      <Webcam width={350} audio={false} ref={webcamRef} />
      {capturing ? (
        <Button sx={{ mt: 0 }} color="success" onClick={handleStopCaptureClick} size="lg">Stop Capture</Button>
      ) : (
        <Button sx={{ mt: 0 }} color="success" onClick={handleStartCaptureClick} size="lg">Start Capture</Button>
      )}
      {recordedChunks.length > 0 && (
        <Button sx={{ mt: 0 }} color="success"  onClick={handleSubmit} size="lg">Submit</Button>
      )}
    </>
  );
};